module.exports = __webpack_public_path__ + "media/images/bricks-6a2cb8c1e59d242ce1c7eb30af3f90b3.png";